import React, { useState } from 'react';
import { Factory, Settings, TrendingUp, CheckCircle2, AlertTriangle } from 'lucide-react';

const PPDSOptimizer = ({ project }) => {
  const [status] = useState({
    pp_ds_active: false,
    mrp_type: 'Classic MRP',
    planning_boards: 0,
    production_models: 0,
    recommendations: [
      { area: 'Production Planning', current: 'PP', target: 'PP/DS', benefit: 'Advanced scheduling with finite capacity', effort_days: 30 },
      { area: 'Demand Management', current: 'MRP', target: 'Demand-Driven MRP', benefit: 'Real-time demand signals', effort_days: 20 },
      { area: 'Capacity Planning', current: 'Basic', target: 'Finite Scheduling', benefit: 'Optimized resource utilization', effort_days: 25 }
    ],
    activation_steps: [
      { step: 'Activate PP/DS component', status: 'pending', effort_days: 5 },
      { step: 'Configure planning boards', status: 'pending', effort_days: 10 },
      { step: 'Create production models', status: 'pending', effort_days: 15 },
      { step: 'Test MRP Live integration', status: 'pending', effort_days: 8 }
    ]
  });

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-3xl font-bold mb-2">PP/DS & MRP Live Optimizer</h2>
        <p className="text-gray-600">Assess PP/DS activation and MRP Live readiness</p>
      </div>

      <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-2xl font-bold mb-2">Current Status</h3>
            <p className="text-blue-100">MRP Type: {status.mrp_type}</p>
          </div>
          <Factory className="w-16 h-16 opacity-50" />
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4">Optimization Opportunities</h3>
        <div className="space-y-3">
          {status.recommendations.map((rec, i) => (
            <div key={i} className="border-2 border-gray-200 rounded-lg p-5">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-900 mb-2">{rec.area}</h4>
                  <div className="grid grid-cols-2 gap-4 text-sm mb-3">
                    <div>
                      <p className="text-gray-500">Current</p>
                      <p className="font-semibold">{rec.current}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">Target</p>
                      <p className="font-semibold text-blue-600">{rec.target}</p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">✓ Benefit: {rec.benefit}</p>
                  <p className="text-xs text-orange-600">Effort: {rec.effort_days} days</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4">Activation Roadmap</h3>
        <div className="space-y-3">
          {status.activation_steps.map((step, i) => (
            <div key={i} className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg">
              <div className="w-10 h-10 bg-purple-600 text-white rounded-full flex items-center justify-center font-bold">{i + 1}</div>
              <div className="flex-1">
                <h4 className="font-semibold">{step.step}</h4>
                <p className="text-sm text-gray-600">Effort: {step.effort_days} days</p>
              </div>
              <span className="px-3 py-1 bg-gray-200 rounded-full text-sm capitalize">{step.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PPDSOptimizer;